const FREE_ADMIN_EMAILS = new Set([
  '9063856@gmail.com',
  'gnedenko1989@gmail.com',
  'dushkniaz@gmail.com',
  'juliatlt63@gmail.com',
]);

export const isFreeAdmin = (email: string | undefined): boolean =>
  !!email && FREE_ADMIN_EMAILS.has(email);
